/**
 * Master-data activity flags already stored as is_active / isActive.
 * Lists and selectors use the active flag; delete sets the inactive flag.
 */
export const CONFIGURATION_RECORD_ACTIVE = true;
export const CONFIGURATION_RECORD_INACTIVE = false;
